import Slider from "react-slick";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { MouseOverTitle } from "../../../Constants/Constants";
import { AutoPlayData, MouseWheelSliderOptions } from "../../../Data/BonusUi/Carousel";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import { Image } from "../../../AbstractElements";

const MouseWheelVariant = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={MouseOverTitle} span={AutoPlayData} />
        <CardBody className="custom-padding-slider">
          <Slider {...MouseWheelSliderOptions}>
            {dynamicNumber(11).map((item, index) => (
              <div className="item px-1" key={index}>
                <Image src={dynamicImage(`slider/${item}.jpg`)} alt="Drawing-room" className="img-fluid rounded" />
              </div>
            ))}
          </Slider>
        </CardBody>
      </Card>
    </Col>
  );
};
export default MouseWheelVariant;
